import { openDB } from "idb";
import { DEFAULT_LANGUAGE } from "./constants";

const DB_NAME = "app-settings";
const STORE_NAME = "config";
const LANGUAGE_KEY = "language";

const getDB = () =>
  openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    },
  });

export async function saveLanguage(lang: string) {
  const db = await getDB();
  await db.put(STORE_NAME, lang, LANGUAGE_KEY);
}

export async function getLanguage(): Promise<string> {
  const db = await getDB();
  const lang = await db.get(STORE_NAME, LANGUAGE_KEY);

  return lang || DEFAULT_LANGUAGE;
}
